// export const URL = 'https://apib2b.auxo.com.pk';
// export const SOCKET_URL = 'https://socketb2b.auxo.com.pk';
// export const PRODUCTION = true;

// //   staging
export const url = `https://coldchainapi.auxo.com.pk`;
// export const url = `http://localhost:8080`;
// const urlV1 = `http://localhost:8080`;
export const PRODUCTION = false;

export const SOCKET_URL = "";
// export const SOCKET_URL = 'http://localhost:8080';
// export const URL = 'http://localhost:8080';
export const URL = '';
// export const PRODUCTION = false;

// export const MVDR_URL = 'https://telenormic.com';
export const apiV1 = '/api/v1';
export const apiV2 = '/api/v2';
export const userCredEncryptionKey = 'aUxO_3@4';
export const socketAuth = 'aUxO_3@4';
export const googleAnalytics = "UA-153479146-1";
